import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
export interface PhotoGridItem {
  description: string;
  image: string;
  url: string;
  name: string;
  featuresPerRow: number;
  actionText: string;
  children?: PhotoGridChildItem[];
}
export interface PhotoGridChildItem {
  name: string;
  url: string;
}
interface Props {
  item: PhotoGridItem;
  showActionButton?: boolean;
  lazyLoadImage?: boolean;
}
const PhotoGridDisplay = ({
  item,
  showActionButton = true,
  lazyLoadImage = false
}: Props) => {
  const itemUrlClasses = !item.url ? "mt-0 xxl:mt-5" : "";
  const displayImageContainer = () => {
    if (item.url) {
      return <a href={item.url} className="img-container img-container--hover block mb-5 overflow-hidden relative" aria-hidden="true" tabIndex={-1}>
          <div className="h-0 m-0 hover:opacity-75 relative transition ease-in-out duration-300 delay-75" style={{
          paddingBottom: "63.5%"
        }}>
            <NoScriptLazyImage className="absolute inset-0 w-full rounded" src={item.image} alt="" disable={!lazyLoadImage} />
          </div>
          {showActionButton && <div className="btn btn-large img-container__btn bg-white border-solid border-2 border-white text-black hover:text-green-600">
              {`Shop ${item.name}`}
            </div>}
        </a>;
    }
    return <div className="h-0 m-0 relative block" style={{
      paddingBottom: "63.5%"
    }} data-sentry-component="displayImageContainer" data-sentry-source-file="index.tsx">
        <NoScriptLazyImage className="absolute inset-0 rounded w-full" src={item.image} role="presentation" disable={!lazyLoadImage} data-sentry-element="NoScriptLazyImage" data-sentry-source-file="index.tsx" />
      </div>;
  };
  const displayTitle = () => {
    if (item.url) {
      return <a href={item.url} className="font-semibold text-sm text-center xs:text-xl xs:mb-1 xs:text-left sm:leading-snug">
          <h2 className="text-base leading-5 mb-0 -mt-2 text-center xs:text-xl xs:leading-5 xs:mt-0 xs:text-left" data-testid="displayTitle">
            {item.name}
          </h2>
          <p className="flex items-center justify-center text-sm leading-4 mt-1 xs:mb-2 xs:justify-start" data-testid="displayCategories">
            {`${item.actionText} `}
            <Icon className="h-4 w-4 fill-current m-0" name="ri-arrow-right-s-line" />
          </p>
        </a>;
    }
    return <h2 className="text-base leading-5 mb-0 mt-3 text-center xs:text-xl xs:leading-5 xs:mb-3 xs:mt-5 xs:text-left" data-testid="displayTitle" data-sentry-component="displayTitle" data-sentry-source-file="index.tsx">
        {item.name}
      </h2>;
  };
  return <div className="photo-grid-display" data-testid="featuredColumn" data-sentry-component="PhotoGridDisplay" data-sentry-source-file="index.tsx">
      {displayImageContainer()}
      <div className={`${item.featuresPerRow % 2 !== 0 && item.children?.length !== 0 ? "xxl:inline-block xxl:float-left xxl:w-2/3" : ""} text-sm leading-snug xs:pr-5`} data-testid="grid__text">
        {displayTitle()}
        <p className="hidden break-words xs:block xs:mb-0" data-testid="displayDescription"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: item.description
      }} />
      </div>
      {!!item.children?.length && <div className={`${item.featuresPerRow % 2 !== 0 && item.children?.length !== 0 ? `xxl:float-left xxl:w-1/3 ${itemUrlClasses}` : ""} ${item.url ? "hidden xs:block" : "block text-center xs:text-left"}`} data-testid="Children Categories">
          {item.children?.map(member => <a href={member.url} className={`block text-sm leading-none mt-2 hover:underline ${item.featuresPerRow % 2 !== 0 && item.children?.length !== 0 ? "xxl:first:mt-0" : ""}`} data-testid="grid__grand-children" key={member.name}>
              {member.name}
            </a>)}
        </div>}
    </div>;
};
export default PhotoGridDisplay;